// appInsights.ts

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createContext } from 'react';

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: 'd506758d-01bf-4a9c-abdc-edddf5cb85c7',
        autoTrackPageVisitTime: true,
        disableFetchTracking: false,
    },
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export const AppInsightsContext = createContext(appInsights);

export default appInsights;

export {};
